import { COLORS } from '@cocolocala/ui-components';

import { LimitedTimeSaleType } from '~/generated/graphql/cocolocala-bff';

export * from './countries';
export * from './loggingCategory';
export * from './messages';

export enum Collection {
  RESET_PASSWORD_USERS = 'resetPasswordUsers',
}

export enum InternationalOrDomestic {
  DOMESTIC = 'DOMESTIC',
  INTERNATIONAL = 'INTERNATIONAL',
}

export enum CurrencyType {
  JPY = 'JPY',
}

export const SIGN_CALLBACK = 'sign_callback';

export const DEFAULT_CHECK_IN_OUT = {
  CHECK_IN_START_TIME: '15:00',
  CHECK_IN_LAST_TIME: '23:00',
  CHECK_OUT_TIME: '10:00',
};

/**
 * ここに分けて計測したいものをいれる。分析に影響するので、変えるときは確認を
 */
export enum LoggingLabel {
  ORDER_FORM_INPUT_BLUR_HIRAGANA_FAMILY_NAME = 'ORDER_FORM_INPUT_BLUR_HIRAGANA_FAMILY_NAME',
  ORDER_FORM_INPUT_BLUR_HIRAGANA_FAST_NAME = 'ORDER_FORM_INPUT_BLUR_HIRAGANA_FAST_NAME',
  ORDER_FORM_INPUT_BLUR_FAMILY_NAME = 'ORDER_FORM_INPUT_BLUR_FAMILY_NAME',
  ORDER_FORM_INPUT_BLUR_FAST_NAME = 'ORDER_FORM_INPUT_BLUR_FAST_NAME',
  ORDER_FORM_INPUT_BLUR_AGE = 'ORDER_FORM_INPUT_BLUR_AGE',
  ORDER_FORM_INPUT_COUNTRY_CODE = 'ORDER_FORM_INPUT_BLUR_COUNTRY_CODE',
  ORDER_FORM_INPUT_ZIP_CODE = 'ORDER_FORM_INPUT_BLUR_ZIP_CODE',
  ORDER_FORM_INPUT_ADDRESS = 'ORDER_FORM_INPUT_BLUR_ADDRESS',
  ORDER_FORM_INPUT_BLUR_MAIL_ADDRESS = 'ORDER_FORM_INPUT_BLUR_MAIL_ADDRESS',
  ORDER_FORM_INPUT_BLUR_TEL = 'ORDER_FORM_INPUT_BLUR_TEL',
  ORDER_FORM_INPUT_BLUR_SEX = 'ORDER_FORM_INPUT_BLUR_SEX',
  ORDER_FORM_INPUT_BLUR_CHECK_IN = 'ORDER_FORM_INPUT_BLUR_CHECK_IN',
  ORDER_FORM_INPUT_BLUR_REMARK = 'ORDER_FORM_INPUT_BLUR_REMARK',
  ORDER_FORM_INPUT_BLUR_PAYMENT_METHOD = 'ORDER_FORM_INPUT_BLUR_PAYMENT_METHOD',
  ORDER_FORM_INPUT_BLUR_CARD_NUMBER = 'ORDER_FORM_INPUT_BLUR_CARD_NUMBER',
  ORDER_FORM_INPUT_BLUR_CARD_MONTH = 'ORDER_FORM_INPUT_BLUR_CARD_MONTH',
  ORDER_FORM_INPUT_BLUR_CARD_YEAR = 'ORDER_FORM_INPUT_BLUR_CARD_YEAR',
  ORDER_FORM_INPUT_BLUR_CARD_CODE = 'ORDER_FORM_INPUT_BLUR_CARD_CODE',
  ORDER_FORM_INPUT_BLUR_PASSWORD = 'ORDER_FORM_INPUT_BLUR_PASSWORD',
  ORDER_FORM_INPUT_BLUR_BIRTHDAY = 'ORDER_FORM_INPUT_BLUR_BIRTHDAY',
  ORDER_FORM_INPUT_BLUR_COUNTRY = 'ORDER_FORM_INPUT_BLUR_COUNTRY',
  ORDER_FORM_INPUT_BLUR_PASSPORT_LIMITED = 'ORDER_FORM_INPUT_BLUR_PASSPORT_LIMITED',
  ORDER_FORM_INPUT_BLUR_PASSPORT_NUMBER = 'ORDER_FORM_INPUT_BLUR_PASSPORT_NUMBER',
  ORDER_FORM_INPUT_BLUR_AGREE = 'ORDER_FORM_INPUT_BLUR_AGREE',
  ORDER_FORM_OPEN_ORDER_DETAIL_MODAL = 'ORDER_FORM_OPEN_ORDER_DETAIL_MODAL',
  ORDER_FORM_SUBMIT_BUTTON_TAP = 'ORDER_FORM_SUBMIT_BUTTON_TAP',
  ORDER_FORM_SUBMIT_SUCCESS = 'ORDER_FORM_SUBMIT_SUCCESS',
  ORDER_FORM_SUBMIT_ERROR_VALIDATION = 'ORDER_FORM_SUBMIT_ERROR_VALIDATION',
  ORDER_FORM_SUBMIT_SIGN_ERROR = 'ORDER_FORM_SUBMIT_SIGN_ERROR',
  ORDER_FORM_SUBMIT_BOOKING_ERROR = 'ORDER_FORM_SUBMIT_BOOKING_ERROR',
  ORDER_FORM_SUBMIT_BOOKING_EXPEDIA_ERROR = 'ORDER_FORM_SUBMIT_BOOKING_EXPEDIA_ERROR',
  ORDER_FORM_SUBMIT_RESERVE_OVERSEAS_AIR_ERROR = 'ORDER_FORM_SUBMIT_RESERVE_OVERSEAS_AIR_ERROR',
  ORDER_FORM_SUBMIT_CREDITCARD_EXECUTION_ERROR = 'ORDER_FORM_SUBMIT_CREDITCARD_EXECUTION_ERROR',
  ORDER_FORM_SUBMIT_CREDITCARD_NOT_FOUND_ERROR = 'ORDER_FORM_SUBMIT_CREDITCARD_NOT_FOUND_ERROR',
  ORDER_FORM_SUBMIT_PAYEASY_ERROR = 'ORDER_FORM_SUBMIT_PAYEASY_ERROR',
  ORDER_FORM_SUBMIT_OTHER_ERRORS = 'ORDER_FORM_SUBMIT_OTHER_ERRORS',
  ORDER_FORM_INPUT_BLUR_PLACE_OF_ISSUE = 'ORDER_FORM_INPUT_BLUR_PLACE_OF_ISSUE',
  COCOLOCALA_ORDER_DOCUMENT_PAGEVIEW = 'COCOLOCALA_ORDER_DOCUMENT_PAGEVIEW',
  // /order/signのページが表示されたとき
  COCOLOCALA_ORDER_NEED_TRAVELPLAN_FINISHED = 'COCOLOCALA_ORDER_NEED_TRAVELPLAN_FINISHED',
  // /order/purchaseが表示されたとき
  COCOLOCALA_VISIT_ORDER_PURCHASE = 'COCOLOCALA_VISIT_ORDER_PURCHASE',
  FOCUS_EMAIL_LINK_INPUT = 'FOCUS_EMAIL_LINK_INPUT',
  SEND_SIGN_UP_LINK_CLICK = 'SEND_SIGN_UP_LINK_CLICK',
  SEND_SIGN_IN_LINK_CLICK = 'SEND_SIGN_IN_LINK_CLICK',
  DID_MOUNT_SIGN_IN_PAGE = 'DID_MOUNT_SIGN_IN_PAGE',
  DID_MOUNT_SIGN_UP_PAGE = 'DID_MOUNT_SIGN_UP_PAGE',
  PLAN_RECOMMEND_INTERVIEW_RESULT = 'PLAN_RECOMMEND_INTERVIEW_RESULT',
  ORDER_FORM_INPUT_BLUR_MAIL_ADDRESS_REPRESENTATIVE = 'ORDER_FORM_INPUT_BLUR_MAIL_ADDRESS_REPRESENTATIVE',
  COCOLOCALA_ORDER_NEED_FLIGHTFORM_FINISHED = 'COCOLOCALA_ORDER_NEED_FLIGHTFORM_FINISHED',
  ORDER_FORM_INPUT_BLUR_FAMILY_NAME_COMPANION = 'ORDER_FORM_INPUT_BLUR_FAMILY_NAME_COMPANION_',
  ORDER_FORM_INPUT_BLUR_FAST_NAME_COMPANION = 'ORDER_FORM_INPUT_BLUR_FAST_NAME_COMPANION_',
  ORDER_FORM_INPUT_BLUR_SEX_COMPANION = 'ORDER_FORM_INPUT_BLUR_SEX_COMPANION_',
  ORDER_FORM_INPUT_BLUR_BIRTHDAY_COMPANION = 'ORDER_FORM_INPUT_BLUR_BIRTHDAY_COMPANION_',
  ORDER_FORM_INPUT_BLUR_COUNTRY_COMPANION = 'ORDER_FORM_INPUT_BLUR_COUNTRY_COMPANION_',
  ORDER_FORM_INPUT_BLUR_PLACE_OF_ISSUE_COMPANION = 'ORDER_FORM_INPUT_BLUR_PLACE_OF_ISSUE_COMPANION_',
  ORDER_FORM_INPUT_BLUR_PASSPORT_NUMBER_COMPANION = 'ORDER_FORM_INPUT_BLUR_PASSPORT_NUMBER_COMPANION_',
  ORDER_FORM_INPUT_BLUR_PASSPORT_LIMITED_COMPANION = 'ORDER_FORM_INPUT_BLUR_PASSPORT_LIMITED_COMPANION_',
  ORDER_FORM_CLICK_TO_SEE_CONFIRMED_PRICE = 'ORDER_FORM_CLICK_TO_SEE_CONFIRMED_PRICE',
}

export const shinkansenAvailableTimeList: [
  [number, number],
  [number, number]
][] = [
  [
    [6, 0],
    [7, 0],
  ],
  [
    [7, 0],
    [8, 0],
  ],
  [
    [8, 0],
    [9, 0],
  ],
  [
    [9, 0],
    [10, 0],
  ],
  [
    [10, 0],
    [11, 0],
  ],
  [
    [11, 0],
    [12, 0],
  ],
  [
    [12, 0],
    [13, 0],
  ],
  [
    [14, 0],
    [15, 0],
  ],
  [
    [15, 0],
    [16, 0],
  ],
  [
    [16, 0],
    [17, 0],
  ],
  [
    [17, 0],
    [18, 0],
  ],
  [
    [18, 0],
    [19, 0],
  ],
  [
    [19, 0],
    [20, 0],
  ],
  [
    [20, 0],
    [21, 0],
  ],
];
export enum TrackingForAnalysisEvent {
  Init = 'Init',
  InterviewStart1 = 'Interview Start 1',
  InterviewStart2 = 'Interview Start 2',
  InterviewStart3 = 'Interview Start 3',
  InterviewStart4 = 'Interview Start 4',
  Q01 = 'Interview Q01',
  Q02 = 'Interview Q02',
  Q03 = 'Interview Q03',
  Q04 = 'Interview Q04',
  Q05 = 'Interview Q05',
  Q06 = 'Interview Q06',
  Q07 = 'Interview Q07',
  Q08 = 'Interview Q08',
  Q09 = 'Interview Q09',
  Q10 = 'Interview Q10',
  Q11 = 'Interview Q11',
  Q12 = 'Interview Q12',
  Q13 = 'Interview Q13',
  Q14 = 'Interview Q14',
  Q15 = 'Interview Q15',
  Q16 = 'Interview Q16',
}

/**
 * 決済手数料
 */
export const PAYMENT_FEE = {
  // コンビニ払い
  CONVENIENCE_STORE: 550,
  // 銀行振込
  BANK_TRANSFER_FINCODE: 550,
  // クレジットカード
  CREDIT_CARD: 0,
} as const;
export type PaymentFee = typeof PAYMENT_FEE[keyof typeof PAYMENT_FEE];

/**
 * ホテルの空室なしの部屋数
 */
export const NO_VACANCY_COUNT = 0;
/**
 * ホテルの残りわずかな部屋数
 */
export const FEW_VACANCY_COUNT = 3;

/**
 * payEasy選択不可になる出発までの日数
 */
export const NotAllowedUsePayEasyPeriod = 5;

/**
 * クーポンのIDをまとめているenum
 */
export enum COUPONS {
  // 新規会員登録の2500円クーポン
  ID_1_NEW_SIGN_UP_2500_YEN = 1,
  // 東京に泊まろうキャンペーンの15,000円クーポン
  ID_2_STAY_IN_TOKYO_15000_YEN = 2,
  // 東京に泊まろうキャンペーンの5%オフクーポン
  ID_3_STAY_IN_TOKYO_5_PERCENT = 3,
  // GO TO トラベルクーポン
  ID_4_GO_TO_TRAVEL = 4,
}

// ABテストのCookie名
export const AB_TESTING_NAMES = {} as const;
export type ABTestingNames = typeof AB_TESTING_NAMES[keyof typeof AB_TESTING_NAMES];

// GoogleフォームURL
export const GOOGLE_FORM_URL = {
  // お客様アンケートフォーム
  QUESTIONNAIRE: 'https://forms.gle/rab6oDS9xdZXZcmo6',
  // 予約の変更・キャンセル・領収書依頼フォーム
  RESERVATION_INQUIRY: 'https://forms.gle/zqwTq4xwfij4sXUT6',
  // 国内旅行キャンセル依頼フォーム
  JP_RESERVATION_INQUIRY: 'https://forms.gle/gSgQYT3GfA24ER567',
  // 海外旅行キャンセル依頼フォーム
  OVERSEAS_RESERVATION_INQUIRY: 'https://forms.gle/BMGUGK65r8xEfWoV9',
} as const;

/**
 * アクセストレードのCVトラッキングに必要な値
 */
export const ACCESS_TRADE_MERCHANT = 'ccoo-tag';
export const ACCESS_TRADE_RESULT_ID = '100';

/**
 * 航空券の予約ステップ
 */
export const ORDER_OVERSEAS_FLIGHT_STEPS = [
  '予約情報入力',
  'お支払い',
  '予約完了',
];

/**
 * ホテル・レンタカーの予約ステップ
 */
export const HOTEL_OR_DP_CAR_STEPS = ['会員登録', '情報入力', '申込完了'];

export const DP_FLIGHT_RESERVATION_STEPS = [
  '会員登録',
  '情報入力',
  'お支払い',
  '申込完了',
];

/**
 * ホテル・海外航空券の予約ステップ
 */
export const DP_FLIGHT_STEPS = ['ホテル', '航空券', '確認・変更', '予約'];

/**
 * 航空券単体の予約ステップ
 */
export const FLIGHT_STEPS = ['航空券', '内容確認', '予約'];

// NOTE: (akutsu) 海外DPのLINE相談アカウントへのリンク
export const LINE_LINK_URL = 'https://lin.ee/MJhTg12';

// NOTE: (@okuda) @cocolocala/ui-componentsに渡すGCSの画像URLのベースのpath
export const UI_COMPONENTS_GCS_IMAGES_BASE_PATH =
  '/images/shared/ui-components';

export const LIMITED_TIME_SALE_CONTENTS = [
  {
    type: LimitedTimeSaleType.BlackFriday,
    label: 'BLACK FRIDAY',
    color: COLORS.STATUS.WARNING_OR_NOTICE,
    backgroundColor: '#000000',
  },
  {
    type: LimitedTimeSaleType.YearEnd,
    label: '歳末SALE',
    color: '#F7D77F',
    backgroundColor: '#CC3032',
  },
  {
    type: LimitedTimeSaleType.NewYear,
    label: '新春SALE',
    color: '#FFFFFF',
    backgroundColor: '#D29B26',
  },
  {
    type: LimitedTimeSaleType.SummerSale,
    label: 'サマーセール',
    color: '#F7D77F',
    backgroundColor: '#1479CA',
  },
];
